import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M114.06302,276 L114.06302,1644.75624 L1.13686838e-13,1644.75624 L1.13686838e-13,276 L114.06302,276 Z M853.168576,349.764555 L933.811131,430.40711 L460.791787,903.426453 L1920,903.426453 L1920,1017.37541 L460.791787,1017.37541 L933.811131,1490.39475 L853.168576,1571.03731 L242.475168,960.3439 L853.168576,349.764555 Z",
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: "1",
  transform: "matrix(-1 0 0 1 1920 0)"
});

var IconMoveRightLine = /*#__PURE__*/function (_Component) {
  _inherits(IconMoveRightLine, _Component);

  var _super = _createSuper(IconMoveRightLine);

  function IconMoveRightLine() {
    _classCallCheck(this, IconMoveRightLine);

    return _super.apply(this, arguments);
  }

  _createClass(IconMoveRightLine, [{
    key: "render",
    value: function render() {
      if (process.env.NODE_ENV !== 'production') {
        console.warn('<IconMoveRightLine /> is deprecated. Please use <IconMoveEndLine /> instead.');
      }

      return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
        name: "IconMoveRight",
        viewBox: "0 0 1920 1920",
        bidirectional: true
      }), _ref);
    }
  }]);

  IconMoveRightLine.displayName = "IconMoveRightLine";
  return IconMoveRightLine;
}(Component);

IconMoveRightLine.glyphName = 'move-right';
IconMoveRightLine.variant = 'Line';
IconMoveRightLine.deprecated = true;
IconMoveRightLine.propTypes = _objectSpread({}, SVGIcon.propTypes);
export default IconMoveRightLine;
export { IconMoveRightLine };